import { useEffect, useState } from 'react'
import { VodRowViewProps } from '@/types/vod/vodRowType'
import { useVODService } from '@/app/context/DIContext/DIServices'
import { useVODStore } from '@/shared/store'
import {
    selectSetVodRows,
    selectVodRows,
} from '@/shared/store/storeSelectors/vodSelectors'
import { getErrorMessage, isStreamIQ } from '@/shared/lib'

export const useSeriesScreen = (): { seriesRows: VodRowViewProps[] } => {
    const [seriesRows, setSeriesRows] = useState<VodRowViewProps[]>([])
    const vodService = useVODService()
    const setVodRows = useVODStore(selectSetVodRows)
    const vodRows = useVODStore(selectVodRows)

    const id = 'SeriesContent'
    const homeContent = vodRows.find((cat) => cat.categoryId === id)

    const getSeriesContent = async () => {
        try {
            if (isStreamIQ() && 'fetchRowsSeriesScreen' in vodService) {
                const response = await vodService.fetchRowsSeriesScreen()

                if (response?.length) {
                    setSeriesRows(response)
                    setVodRows(response, id)
                } else if (!response?.length && homeContent?.rows.length) {
                    setSeriesRows(homeContent.rows)
                    return
                } else {
                    console.log('No data fetched or cached for Series Page')
                }
            }
        } catch (error) {
            getErrorMessage('fetchRowsHome', error)
        }
    }

    useEffect(() => {
        getSeriesContent()
    }, [vodRows])

    return { seriesRows }
}
